/**
 * 业务字段配置文件
 */


let dict = {
  BMerchant: {
    // 开封和彩达电子科技有限公司1 羊庆菊
    "kfhcddzkjyxgs_z2y" : {
      merchantName: "开封和彩达电子科技有限公司",
      contactName: "吴海燕",
      contactMobile: "18810277782",
      contactEmail: "qjyang@rongketech.com",
      contactAddress: "河南省开封市通许县练城乡财政所便民服务大厅6号楼",
      serviceRate: "6.9",
    },
    "hbnythlwxxkjyxgs_z2y" : {
      merchantName: "湖北牛运通互联网信息科技有限公司",
      contactName: "冯煜",
      contactMobile: "18810277782",
      contactEmail: "qjyang@rongketech.com",
      contactAddress: "房县城关镇滨河花园5号",
      serviceRate: "6.9",
    },
    // 舟山兰和科技有限公司
    "zslhkjyxgs" : {
      merchantName: "舟山兰和科技有限公司",
      legalName: "钟韬晨",
      contactName: "羊庆菊",
      contactMobile: "18810277782",
      contactEmail: "qjyang@rongketech.com",
      contactAddress: "浙江省舟山市定海区舟山港综合保税区企业服务中心301-3045室(自贸试验区内)",
      serviceRate: "",
    },
    // 舟山丽唐科技有限公司
    "zsltjkyxgs" : {
      merchantName: "舟山丽唐科技有限公司",
      legalName: "钟韬晨",
      contactName: "羊庆菊",
      contactMobile: "18810277782",
      contactEmail: "qjyang@rongketech.com",
      contactAddress: "浙江省舟山市定海区舟山港综合保税区企业服务中心301-3046室(自贸试验区内)",
      serviceRate: "",
    },
    // 洛阳风间科技有限公司
    "lyfjkjyxgs" : {
      merchantName: "洛阳风间科技有限公司",
      legalName: "冯煜",
      contactName: "羊庆菊",
      contactMobile: "18810277782",
      contactEmail: "qjyang@rongketech.com",
      contactAddress: "河南省洛阳市洛龙区长夏门街32号863创智广场1幢1205室",
      serviceRate: "",
      noticeImages:[
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yznotice/00.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yznotice/01.png"
      ],
      noticeTemplateImages:[
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yzlyfjtemplate/00.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yzlyfjtemplate/01.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yzlyfjtemplate/02.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yzlyfjtemplate/03.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yzlyfjtemplate/04.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yzlyfjtemplate/05.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yzlyfjtemplate/06.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yzlyfjtemplate/07.png",
      ],
    },
    // 河南企泰云科技有限公司
    "qtykjyxgs" : {
      merchantName: "河南企泰云科技有限公司",
      legalName: "张军红",
      contactName: "羊庆菊",
      contactMobile: "18810277782",
      contactEmail: "qjyang@rongketech.com",
      contactAddress: "河南省周口市川汇区新民路翰墨文化艺术中心4层408室",
      serviceRate: "",
      noticeImages:[
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yznotice/20240729_1.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yznotice/20240729_2.png"
      ],
      noticeTemplateImages:[
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yznotice/20240729_1.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yznotice/20240729_2.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yzqitaiyun/00.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yzqitaiyun/01.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yzqitaiyun/02.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yzqitaiyun/03.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yzqitaiyun/04.png",
        "https://bpo-prod.oss-cn-beijing.aliyuncs.com/static/template/yzqitaiyun/05.png",
      ],
    },
  }
}

module.exports = dict;



// WEBPACK FOOTER //
// ./src/utils/businessDict.js